import React from 'react';

export type K = React.KeyboardEvent<HTMLElement>;
export type M = React.MouseEvent<HTMLElement>;

export type ExternalClickEvents = 'click' | 'mousedown' | 'keyup';

export interface IExternalClickWrapperProps {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits **esc** key.
   */
  onExternal?: (e: K | M) => void;
  /**
   * Disable the the ExternalClickWrapper, preventing it from triggering `onExternal`.
   * @default false
   */
  disabled?: boolean;
  /**
   * Choose which document mouse event to bind to.
   * @default 'click'
   */
  event?: 'click' | 'mousedown';
}
